<template>
  <sp-select
    v-preserve-properties:items="items"
    :disabled="disabled"
    class="availability-time-select"
    :aria-label="prompt"
    :value.attr="value"
    :prompt="prompt"
    :data-testid="TestId.finder.availabilityTime"
    :item-test-id="TestId.finder.availabilityTimeOption"
    @input="handleInput"
  ></sp-select>
</template>

<script setup>
import { vPreserveProperties } from "#ce/utils/property-bindings";
import { computed } from "vue";
import { firstDetail } from "#ce/utils/events";
import { toBoolean, emptyToUndefined } from "#ce/utils/props";
import { TestId } from "#/test-ids";
import { AVAILABLE_TIMES } from "#ce/shared/filters/availability/composables/useAvailabilityFilterModel";
import { t } from "#ce/shared/filters/availability/i18n";

const emit = defineEmits(["select"]);

const props = defineProps({
  disabled: { type: Boolean, default: false },
  /** The selected `available_times` value. */
  value: {
    type: String,
    default: undefined,
  },
});

const prompt = computed(() => t("time_prompt"));

const items = computed(() => [
  { title: t("time_morning"), value: AVAILABLE_TIMES.morning },
  { title: t("time_afternoon"), value: AVAILABLE_TIMES.afternoon },
]);

function handleInput(event) {
  if (toBoolean(props.disabled)) {
    return;
  }
  emit("select", emptyToUndefined(firstDetail(event)));
}
</script>

<style lang="scss" scoped>
.availability-time-select {
  display: block;
  width: 100%;
}
</style>
